import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { formatNumber, palette, Tip, Typography } from '@dev/ee-components';
import { ABSummaryProps } from '../ABReadyToInterface';

const CenterRecipientsCount = styled.div`
    display: flex;
    align-items: center;
    justify-contend: space-between;
`;

const LeftSide = styled.div`
    display: flex;
`;

const DataWrapper = styled.div`
    padding: 20px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${palette.gray[3]};

    &:last-of-type {
        border-bottom: none;
    }
`;

const Version = styled.div`
    width: 170px;
`;

export const VersionsSummary: FC<ABSummaryProps> = ({
    alphabetSignature,
    uniqueRecipients,
    uniqueRecipientsPercent,
}): JSX.Element => {
    const { t } = useTranslation();

    return (
        <DataWrapper>
            <LeftSide>
                <Version>
                    <Typography variant="body2" bodyVariant="help">
                        {`${t('version')} ${alphabetSignature}`}
                    </Typography>
                </Version>
                <CenterRecipientsCount>
                    <Typography variant="h4">{`${formatNumber(uniqueRecipients)} ${t('uniquerecipients')}`}</Typography>
                    <Typography
                        variant="body2"
                        bodyVariant="help"
                        style={{ marginLeft: '4px' }}
                    >{`(${uniqueRecipientsPercent}%)`}</Typography>
                </CenterRecipientsCount>
            </LeftSide>
            {uniqueRecipients < 1000 && (
                <Tip id={`send-summary-tooltip`}>
                    <Typography variant="body1" bodyVariant="onPaper">
                        {t('werecommendsettingup')}
                    </Typography>
                </Tip>
            )}
        </DataWrapper>
    );
};
